// 
import $ from 'jquery';
import {
  execute,
  executeSubmit,
} from './partialUpdate';

if (!$.partialUpdate) {
  $.partialUpdate = {};
}
$.partialUpdate.execute = (url, containerId, callback, settings) => {
  execute({
    url,
    target: containerId,
    onAfterContentsReplace: ({
      replacementDiv,
      result,
      // accessibleNewContainer,
      // settings,
      // jqXHR,
      // xhr,
      // textStatus,
    }) => {
      callback(replacementDiv, result);
    },
    ...settings,
  });
};

$.partialUpdate.executeSubmit = (
  submitId,
  containerId,
  callback,
  settings,
  exceptWidgetData,
  exceptParams,
) => {
  executeSubmit({
    submitId,
    target: containerId,
    onAfterContentsReplace: ({
      replacementDiv,
      result,
    }) => {
      callback(replacementDiv, result);
    },
    removeContainerWidgetData: exceptWidgetData,
    exceptParams,
    ...settings,
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/oldPolyfill.js